export enum OrganizationType {
    EXPERT = 'expert',
    ESSENTIAL = 'essential',
    SYRINX = 'syrinx'
}
